import { toSnakeCaseKeysNested } from './mapKeysNested';
import type { RequestPaymentParameters } from '../types';

type GeneratePaymentRequestOptions = {
  paymentMethodData?: io.flow.v0.unions.PaymentMethodData;
};

export default function generatePaymentRequestForm(
  params: RequestPaymentParameters,
  options: GeneratePaymentRequestOptions = {},
): io.flow.v0.models.PaymentRequestForm {
  return {
    amount: params.data.amount,
    currency: params.data.currency,
    return_url: params.data.returnUrl,
    order_information: toSnakeCaseKeysNested<RequestPaymentParameters['data']['orderInformation'], io.flow.v0.models.PaymentRequestForm['order_information']>(params.data.orderInformation),
    payment_method_data: options.paymentMethodData,
    reference: params.data.reference,
    supported_actions: params.config.supportedActions,
    device_details: {
      type: 'browser',
      origin: window.location.origin,
      user_agent: navigator.userAgent,
      accept_language: navigator.languages.join(','),
    },
  };
}
